import type { ReactNode } from 'react';
import type { CardTone } from './Card';
import { CardHeading } from './CardHeading';
import { CardLink } from './CardLink';
import { Muted } from './Muted';
import { StatusBadge, type StatusTone } from './StatusBadge';
import styles from './ui.module.css';

/**
 * Переход в раздел: значок слева, название с пояснением и стрелка справа.
 *
 * Заводится по факту — этот вид объявили у себя и кабинет, и вкладка «Ещё».
 * Пояснение обязательно: без него список разделов превращается в меню из
 * голых слов, по которым непонятно, что внутри.
 *
 * Стрелка не украшение: карточка нажимается целиком, и без неё она ничем не
 * отличается от карточки-сводки, которая никуда не ведёт.
 */
export function NavCard({
  title,
  hint,
  icon = null,
  badge = null,
  badgeTone = 'pending',
  tone = 'default',
  onOpen,
}: {
  title: string;
  hint: string;
  /** Значок раздела. У «Ещё» его нет: там разделы разнородные. */
  icon?: ReactNode;
  /** Непрочитанное и подобное. У большинства разделов считать нечего. */
  badge?: string | null;
  /** Тон значка: у непрочитанных решений он малиновый, как и контур карточки. */
  badgeTone?: StatusTone;
  /** Контур отказа у необратимого раздела: удаление своих данных. */
  tone?: CardTone;
  onOpen: () => void;
}) {
  return (
    <CardLink onClick={onOpen} label={title} tone={tone} chevron>
      <div className={styles.navRow}>
        {icon === null ? null : <span className={styles.navIcon}>{icon}</span>}

        <span className={styles.navBody}>
          <CardHeading
            badge={badge === null ? undefined : <StatusBadge tone={badgeTone}>{badge}</StatusBadge>}
            badgeAt="title"
          >
            <span className={tone === 'rejected' ? styles.navTitleDanger : undefined}>{title}</span>
          </CardHeading>
          <Muted>{hint}</Muted>
        </span>
      </div>
    </CardLink>
  );
}
